import React, { createContext, useContext, useState } from "react";
import { getRegion, setStoredRegion } from "./lib/region";

const RegionContext = createContext(null);

export function RegionProvider({ children }) {
  const [region, setRegionState] = useState(getRegion);

  function setRegion(nextRegion) {
    setStoredRegion(nextRegion);
    setRegionState(nextRegion);
  }

  return (
    <RegionContext.Provider value={{ region, setRegion }}>
      {children}
    </RegionContext.Provider>
  );
}

export function useRegion() {
  const context = useContext(RegionContext);
  if (!context) throw new Error("useRegion must be used within a RegionProvider");
  return context;
}
